import { AxiosResponse } from 'axios';
import AxiosInstanceBFF from './AxiosInstanceBFF';

export type GetBotsByClientResponse = {
  botID: string;
};

export const getBotsByClient = async (): Promise<AxiosResponse<GetBotsByClientResponse[]>> =>
  AxiosInstanceBFF.get('v1/bot');
